import ApiV1 from "@/configs/axios/ApiV1";
import { HasPermissionOrThrow } from "@/utils/permisshoinHelper";
import PermissionsV1 from "@/router/permissions/v1";

export function authGetOptions() {
  return ApiV1.get("auth/options");
}

export function authLogin(payload) {
  return ApiV1.post("auth/login", payload);
}

export function authLogout() {
  return ApiV1.post("auth/logout");
}

export function AuthChangePassword(data) {
  return ApiV1.post("/auth/change-password", data);
}

export function authLoginEkyzmat(payload) {
  return ApiV1.post("auth/login/ekyzmat", payload);
}

export function userAddSelectonContact(id, payload) {
  HasPermissionOrThrow(PermissionsV1["USERS.ITEM.ADD_SELECTION_CONTACT"]);

  return ApiV1.post(`users/${id}/selectionContact`, payload);
}
